// frontend/src/components/FinanceReport/Accounting/components/AccountingTabs.jsx

import React from "react";

const tabs = [
  { id: "accounting", label: "Первичная бухгалтерия" },
  { id: "accounts", label: "Счета" },
  { id: "currencies", label: "Валюта" },
  { id: "finance-report", label: "Финансовая отчётность" },
  { id: "agents", label: "Список платежных агентов" },
];

export default function AccountingTabs({ active, setActive }) {
  return (
    <div className="flex flex-wrap items-end mb-0">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActive(tab.id)}
          className={`
            px-6 py-3 border border-b-0 rounded-t-lg font-medium transition
            ${
              active === tab.id
                ? "bg-white text-blue-600 shadow-sm"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }
          `}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}